import { Directive, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[fbDisableControl]',
})
export class DisableControlDirective {
  @Input() set fbDisableControl(disable: boolean) {
    this.setStatus(disable);
  }

  @Input() isEmitEvent: boolean = false;

  constructor(private ngControl: NgControl) {}

  private setStatus(disable: boolean): void {
    this.ngControl.control[disable ? 'disable' : 'enable']({
      emitEvent: Boolean(this.isEmitEvent),
    });
  }
}
